module.exports = __webpack_public_path__ + "static/img/QXzr.735cb96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QXzr.png
// module id = lV6v
// module chunks = 0